"use client";

import dynamic from "next/dynamic";

const SuperOfferModal = dynamic(() => import("./SuperOfferModal"), {
  ssr: false,
});

interface Props {
  companyId: string;
  domain: string;
  pageKey?: string;
}

const LazySuperOfferModal = (props: Props) => {
  return <SuperOfferModal {...props} />;
};

export default LazySuperOfferModal;